import React from 'react'
const TranscriptLine = ({ cue, seek, currentTime, showTime }) => {
  let style = ''
  if (cue.startTime <= currentTime && cue.endTime >= currentTime) {
    style = 'active'
  }
  const onClick = () => {
    seek(cue.startTime, cue.endTime)
  }
  const formatSeconds = (t) => {
    let mins = Math.floor(t / 60)
    if (mins < 10) {
      mins = `0${mins}`
    }

    let secs = Math.floor(t % 60)
    if (secs < 10) {
      secs = `0${secs}`
    }
    return `${mins}:${secs}`
  }

  const startTime = formatSeconds(cue.startTime)
  const endTime = formatSeconds(cue.endTime)

  return (
    <div className={`${style} line`} onClick={onClick}>
      {showTime && (
        <div className="time">
          [{startTime} - {endTime}]
        </div>
      )}
      <div
        className={`${style} text`}
        dangerouslySetInnerHTML={{ __html: cue.text }}
      />
    </div>
  )
}

export default TranscriptLine
